import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useZakatWizard, NisabStandard } from '../../hooks/useZakatWizard';
import { Button } from '../ui/Button';
import { StepIndicator } from './StepIndicator';
import { RunningTotal } from './RunningTotal';
// Steps
import { WelcomeStep } from './steps/WelcomeStep';
import { CashStep } from './steps/CashStep';
import { InvestmentsStep } from './steps/InvestmentsStep';
import { RetirementStep } from './steps/RetirementStep';
import { GoldSilverStep } from './steps/GoldSilverStep';
import { MoneyOwedToYouStep } from './steps/MoneyOwedToYouStep';
import { BusinessAssetsStep } from './steps/BusinessAssetsStep';
import { DebtsStep } from './steps/DebtsStep';
import { EmailStep } from './steps/EmailStep';
import { SummaryStep } from './steps/SummaryStep';
export function ZakatWizard() {
  const {
    currentStepIndex,
    currentStep,
    steps,
    isFirstStep,
    isLastStep,
    nextStep,
    prevStep,
    state,
    updateState,
    resetWizard,
    totals,
    constants
  } = useZakatWizard();
  const handleNisabChange = (standard: NisabStandard) => {
    updateState({
      nisabStandard: standard
    });
  };
  const handleEmailSubmit = () => {
    nextStep();
  };
  const handleEmailSkip = () => {
    nextStep();
  };
  const renderStep = () => {
    switch (currentStep) {
      case 'welcome':
        return <WelcomeStep state={state} updateState={updateState} data-id="element-156" />;
      case 'cash':
        return <CashStep state={state} updateState={updateState} data-id="element-157" />;
      case 'investments':
        return <InvestmentsStep state={state} updateState={updateState} data-id="element-158" />;
      case 'retirement':
        return <RetirementStep state={state} updateState={updateState} data-id="element-159" />;
      case 'goldSilver':
        return <GoldSilverStep state={state} updateState={updateState} data-id="element-160" />;
      case 'moneyOwedToMe':
        return <MoneyOwedToYouStep state={state} updateState={updateState} data-id="element-161" />;
      case 'business':
        return <BusinessAssetsStep state={state} updateState={updateState} data-id="element-162" />;
      case 'debts':
        return <DebtsStep state={state} updateState={updateState} data-id="element-163" />;
      case 'email':
        return <EmailStep state={state} updateState={updateState} totals={totals} onSubmit={handleEmailSubmit} onSkip={handleEmailSkip} data-id="element-164" />;
      case 'summary':
        return <SummaryStep state={state} totals={totals} constants={constants} onNisabChange={handleNisabChange} onReset={resetWizard} data-id="element-165" />;
      default:
        return null;
    }
  };
  // Don't show navigation on email step (it has its own submit) or summary
  const showNavigation = currentStep !== 'email' && currentStep !== 'summary';
  return <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start" data-id="element-166">
      {/* Main Wizard Area */}
      <div className="lg:col-span-8" data-id="element-167">
        <StepIndicator currentStepIndex={currentStepIndex} totalSteps={steps.length} currentStepName={currentStep} data-id="element-168" />

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 md:p-8 min-h-[400px] relative overflow-hidden" data-id="element-169">
          <AnimatePresence mode="wait" data-id="element-170">
            <motion.div key={currentStep} initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} transition={{
            duration: 0.3
          }} data-id="element-171">
              {renderStep()}
            </motion.div>
          </AnimatePresence>
        </div>

        {/* Navigation Buttons */}
        {showNavigation && <div className="flex justify-between mt-8 pb-20 lg:pb-0" data-id="element-172">
            <Button variant="outline" onClick={prevStep} disabled={isFirstStep} className={isFirstStep ? 'invisible' : ''} data-id="element-173">
              Back
            </Button>

            <Button onClick={nextStep} className="px-8" data-id="element-174">
              Next Step
            </Button>
          </div>}

        {/* Back button only for email step */}
        {currentStep === 'email' && <div className="flex justify-start mt-8 pb-20 lg:pb-0" data-id="element-175">
            <Button variant="outline" onClick={prevStep} data-id="element-176">
              Back
            </Button>
          </div>}
      </div>

      {/* Sticky Sidebar */}
      <div className="lg:col-span-4" data-id="element-177">
        <RunningTotal totals={totals} nisabStandard={state.nisabStandard} onNisabChange={handleNisabChange} emailSubmitted={state.emailSubmitted} constants={constants} data-id="element-178" />
      </div>
    </div>;
}